import { shouldShowMailCommandCenterPlaceholder } from 'owa-copilot-command-center-components/lib/utils/shouldShowMailCommandCenterPlaceholder';
import { setShouldRenderCommandCenterPlaceholderMutator } from 'owa-copilot-command-center-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { updateBizchatEnabledMutator } from 'owa-sidepane-bizchat-store/lib/mutators/updateBizchatEnabledMutator';
import { getBootM365Acquisitions } from 'owa-m365-acquisitions/lib/getBootM365Acquisitions';
import getBizChatAppId from 'owa-m365-acquisitions/lib/utils/getBizChatAppId';
import { isUserPinnedStubAcquisition } from 'owa-m365-acquisitions/lib/utils/isUserPinnedStubAcquisition';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

export function initializeCopilotCommandCenter(mailboxInfo: MailboxInfo): void {
    if (!isGlobalFeatureEnabled('mon-copilot-command-center-preload')) {
        return;
    }
    if (shouldShowMailCommandCenterPlaceholder(window)) {
        setShouldRenderCommandCenterPlaceholderMutator(true);
    }
    getBootM365Acquisitions(mailboxInfo).then(response => {
        const { acquisitions } = response;
        const bizchatAppId = getBizChatAppId(mailboxInfo);
        const bizchatAcquisition = acquisitions.find(
            acquisition => acquisition.appId === bizchatAppId
        );
        if (bizchatAcquisition !== undefined) {
            // Boot acquisitions can contain a locally synthesized stub for a pinned app bar
            // tile rather than real service data. Its eligibility is empty, so seeding the
            // store from it would record the user as Copilot-ineligible and suppress the
            // eligibility fetch that would otherwise correct it.
            if (isUserPinnedStubAcquisition(bizchatAcquisition)) {
                return;
            }
            const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
            updateBizchatEnabledMutator(
                accountKey,
                true,
                bizchatAcquisition?.titleDefinition?.eligibility ?? undefined
            );
        }
    });
}
